import BaseModel from "../core/BaseModel";
export default class ContractorModel extends BaseModel {
  constructor() {
    super(
      {
        name: "contractor",
        tableName: "contractor",
        label: "Danh sách nhà thầu",
        display_key: "name",
      },
      {
        stt: { 
          name: "stt", 
          label: "STT",
          class: 'center', 
          computed: (data, index) => {
            data.stt = index + 1;
          }
        },
        id: {
          name: "id",
          type: "Uuid",
          label: "ID",
          primaryKey: true,
          display: false,
        },
        code: {
          name: "code",
          type: "String",
          label: "Mã nhà thầu",
          filter: { type: "input", match: "contains" },
        },
        name: {
          name: "name",
          type: "String",
          label: "Tên nhà thầu",
          filter: { type: "input", match: "contains" },
        },
        number_ns : {
          name: 'number_ns', 
          type: "CustomUrl", 
          label: 'Nhân sự',
          width: 5,
          class: 'center',
          computed: (data) => {
            data.number_ns = 0;
          }
        },
        text_status:{
          name: 'text_status', 
          type: "Text", 
          label : "Trạng thái cung cấp dịch vụ",
          // width: 10,
          computed: (data) => {
            data.text_status = "";
          },
          // filter: { type: "input", match: "contains" },
        },
        reuse : {
          name: 'reuse', 
          type: "CustomUrl", 
          label: 'Sử dụng tiếp',
          width: 6,
          class: 'center',
          computed: (data) => {
            data.reuse = 0;
          },
          display : false,
        },
        last_review:{
          name: 'last_review',
          type: 'Text',
          label: 'Đánh giá cuối',
          computed: (data) => {
            data.last_review = '';
          },
        },
        number_sra:{
          name: 'number_sra', 
          type: "CustomUrl", 
          label : "SL gói công việc",
          minWidth: 5,
          class: "center",
          computed: (data) => {
            data.number_sra = 0;
          },
        },
        service_text: {
          name: "service_text",
          type: "Text",
          label: "Dịch vụ",
          filter: { type: "input", match: "contains" },
        },
        number_atw : {
          name: 'number_atw', 
          type: "CustomUrl", 
          label: 'ATW',
          width: 4,
          class: 'center',
          computed: (data) => {
            data.number_atw = 0;
          },
          display : false,
        },
        active: {
          name: "active",
          type: "Boolean",
          label: "Hiển thị",
          class: "center",
          display : false,
        },
        status_text: {
          name: "status_text",
          type: "Text",
          label: "Trạng thái",
          computed: (data) => {
            data.status_text = "";
          },
          display : false,
        },
        manager_fullname: {
          name: "manager_fullname",
          type: "Text",
          label: "Người phụ trách nhà thầu",
          // filter: { type: "input", match: "contains" },
        },
        total_hours_by_sra: {
          name: "total_hours_by_sra",
          type: "Text",
          label: "Tổng số giờ làm việc",
          class: 'center',
        },

        updated_by: {
          name: "updated_by",
          type: "String",
          label: "Người cập nhật",
          display : false,
        },

        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối",
          display : false,
        },

        deleted: {
          name: "deleted",
          label: "Xóa",
          type: "Checkbox",
          display: false,
        },
      }
    );
  }
}
